import { defineStore, acceptHMRUpdate } from 'pinia'
import moment from 'moment'
import { router } from '@/router/index.js'

export const tokenStore = defineStore('tokenStore', {
  state: () => {
    return {
      currentToken: null,
      payload: {}
    }
  },
  getters: {
    getCurrentToken(state) {
      return state.currentToken
    },
    getTokenPayload(state) {
      return state.payload
    }
  },
  actions: {
    async checkAndSaveToken(token) {
      try {
        if(token) {
          let regex = /^[A-Za-z0-9_-]{2,}(?:(=|\.)[A-Za-z0-9_-]{2,}){2}$/
          // Check if jwt is a formated correctly (= is also a valid caracter in our case)
          if (regex.test(token)) { 
            token = token.replace(/=/g, '.')
            // Decode payload
            let payload = JSON.parse(atob(token.split('.')[1])) 
            if (payload.aud === 'octiapp-datacapture' && payload.iss === 'octiapp-api') {
              if (moment.utc(payload.exp) > moment.utc()) {
                this.currentToken = token
                this.payload = payload
                return true
              }
            }
          }
        }
        return false
      } catch (e) {
        if (import.meta.env.VITE_ENVIRONMENT !== 'prod') {
          console.error(e)
        }
      }
    },
    clearToken() {
      this.currentToken = null
      this.payload = null
    }
  }
})


if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(tokenStore, import.meta.hot))
}
